import { useResourceContext } from "@/layouts/ResourceContext";
import { Show } from "@refinedev/antd";
import { useOne, CanAccess, useInvalidate, useUpdate } from "@refinedev/core";
import { Empty, Result, Spin, Table, Card, Button } from "antd";
import { useTranslation } from "react-i18next";
import { InstanceStatus } from "@/components/instance/InstanceStatus";
import { useState, useEffect } from "react";

export const NodegroupsDetailPanel = ({resource="nodegroups"}) => {
  const { t } = useTranslation();
  const { state, dispatch } = useResourceContext();
  const { selectedResources: [selectedNodegroup] } = state;
  const { data, isLoading, isError } = useOne({
    resource: 'nodegroups', 
    id: selectedNodegroup?.id
  });
  const [isRetrying, setIsRetrying] = useState(false);
  const [status, setStatus] = useState("");
  const invalidate = useInvalidate();
  useEffect(() => {
    setStatus(selectedNodegroup?.status);
  }, [selectedNodegroup]);
  const { mutate: retryCreate } = useUpdate({
    resource,
    successNotification: (data1, values, resource) => {
      setIsRetrying(false);
      invalidate({
        resource,
        invalidates: ["list"],
      });

      const s = data1?.status;
      setStatus(s);
      return {
        message: t(`${resource}.actionResult.retry.success`, {
          id: values?.id,
        }),
        type: "success",
      };
    },
    errorNotification: (data1, values, resource) => {
      setIsRetrying(false);
      return {
        message:
          t(`${resource}.actionResult.retry.failed`, {
            id: values?.id,
          }) +
          "--" +
          data1?.message,
        type: "error",
      };
    },
  });
  const handleRetryClick = (e, id) => {
    e.preventDefault();
    setIsRetrying(true);
    retryCreate({
      id,
      values: { action: "retry" },
    });
  };
  return (
    <>
      { isError && 
        <Result
          status="500"
          title="500"
          subTitle="Sorry, something went wrong."
        />
      }
      { !isError && (!selectedNodegroup || !isLoading && !data.nodegroups) && <Empty description={false} /> }
      { isLoading && <Spin size="large" /> }
      { !isLoading && !isError &&     
      <Card title={(
          <>
            <span style={{ paddingRight: 20 }}>{selectedNodegroup.id}</span>
            <InstanceStatus status={status} />
            <span style={{ paddingLeft: "10px" }}></span>
            {status?.indexOf("failed") != -1 && selectedNodegroup.type != "instance" &&(
              <CanAccess resource={resource} action="retry">
                <Button
                  style={{ paddingLeft: "10px" }}
                  to="retry"
                  loading={isRetrying}
                  onClick={(e) => handleRetryClick(e, selectedNodegroup.id)}
                >
                  {t("actions.retry", "Retry")}
                </Button>
              </CanAccess>
            )}
          </>
        )
      }
      style={{ width: '100%' }}
    >
        <Table
          dataSource={data.nodegroups}
          columns={[
            { title: t('nodegroups.fields.name'), dataIndex: 'name', key: 'name' },
            { title: t('nodegroups.fields.machine'), dataIndex: 'instanceTypes', key: 'instanceTypes' },
            { title: t('nodegroups.fields.desiredSize'), dataIndex: 'desiredSize', key: 'desiredSize' },
            { title: t('nodegroups.fields.minSize'), dataIndex: 'minSize', key: 'minSize' },
            { title: t('nodegroups.fields.maxSize'), dataIndex: 'maxSize', key: 'maxSize' },
            { title: t('nodegroups.fields.version'), dataIndex: 'version', key: 'version' },
            { title: t('nodegroups.fields.status'), dataIndex: 'status', key: 'status' },
          ]}
        />
      </Card> }
    </>
  );
};